var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRainfallLevelCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1689db"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-559.962-473.717h36v36h-36Z",
    transform: "translate(559.962 473.717)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.15 4.399)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.516,
    height: 2.789,
    transform: "translate(12.152 25.75) rotate(-58.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.145,
    height: 2.789,
    transform: "translate(6.03 25.519) rotate(-58.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533.9-461.748c-.136,0-.273,0-.408.013a8.748,8.748,0,0,0-8.562-7.094,8.722,8.722,0,0,0-8.711,8.713c0,.038,0,.076,0,.113a6.338,6.338,0,0,0-4.88,6.181,6.349,6.349,0,0,0,5.6,6.3l.286.034,1.7-2.774h-1.232a3.568,3.568,0,0,1-3.563-3.563,3.57,3.57,0,0,1,3.537-3.563l1.749,0-.305-1.649a5.963,5.963,0,0,1-.1-1.085,5.931,5.931,0,0,1,5.924-5.925,5.934,5.934,0,0,1,5.924,5.9v1.906l1.795-.54a4.366,4.366,0,0,1,1.252-.185,4.356,4.356,0,0,1,4.351,4.35,4.356,4.356,0,0,1-4.351,4.351h-.683l-1.706,2.788h2.389a7.147,7.147,0,0,0,7.14-7.139A7.148,7.148,0,0,0-533.9-461.748Z",
    transform: "translate(556.462 468.829)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRainfallLevelCircle);
export default __webpack_public_path__ + "static/media/icon_rainfall-level--circle.8d4a0847944ab7e8295ca30d6403c464.svg";
export { ForwardRef as ReactComponent };